import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';
import { SzPillComponent } from '../sz-pill/sz-pill.component';
import { SzDrillType } from './sz-type-pill.types';

@Component({
  selector: 'sz-type-pill',
  templateUrl: './sz-type-pill.component.html',
  styleUrls: ['./sz-type-pill.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SzPillComponent]
})
export class SzTypePillComponent {
  readonly type: InputSignal<SzDrillType> = input.required<SzDrillType>();
}
